import InternalStaticAnchorFAQ from 'models/application/anchor/types/internalStatic/types/FAQ';

export default class InternalStaticAnchorFAQService {
	toModel(anchor) {
		return new InternalStaticAnchorFAQ(anchor);
	}
}
